import React, { Component } from 'react';
import {MainLayout} from 'components/layouts';
import {ProductList} from 'components/fair/fair-product';
import {Link} from 'react-router-dom';

export default class FairProductsAwaiting extends Component {

  render() {
    return (
      <MainLayout>
        <div>
          <div className='mb15'>
            <Link className='btn-back' to={`/fair/${this.props.match.params.id}`}><i className='fa fa-chevron-left' />Quay về trang chi tiết hội chợ</Link>
          </div>
          <div className='wrap-heading'>
            <h1>Các sản phẩm đang chờ duyệt</h1>
            <div className='list-actions'>
              <Link to={`/fair/${this.props.match.params.id}/products`}>Sản phẩm của hội chợ</Link>
            </div>
          </div>
          <ProductList status="AWAITING" match={this.props.match}/>
        </div>
      </MainLayout>
    );
  }
}



// WEBPACK FOOTER //
// ./pages/fair/fair-products/FairProductsAwaiting.jsx